export default {
  'stone.establishment.notification.success': 'Sucesso',

  'stone.establishment.create.notification.successDescription': 'Estabelecimento cadastrado com sucesso!',
  'stone.establishment.update.notification.successDescription': 'Estabelecimento reativado com sucesso!',

  'stone.establishment.remove.notification.successDescription': 'Estabelecimento desativado com sucesso!',

  
  'stone.pos.notification.success': 'Sucesso',

  'stone.pos.create.notification.successDescription': 'Configurações salvas com sucesso!',

};
